import { Avatar, Box, makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import CustomDialog from '../CustomDialog'
import Logo from '../../assets/images/certificateLogo.png'
import Logo2 from '../../assets/images/logo2.png'
import CustomImage from '../CustomImage'
import CustomButton from '../CustomButton'

const useStyles = makeStyles((theme) => ({
  boldLine: {
    borderLeft: '12px solid #C9AA4F',
    height: '500px',
  },
  thinLine: {
    borderRight: '6px solid #C9AA4F',
    height: '500px',
    marginLeft: '10px',
  },
  dialog: {
    minWidth: '750px',
  },
  thinLine2: {
    marginRight: '10px',
  },
  certificateHeading: {
    fontSize: '23px',
    margin: '35px 0px 25px 0px',
  },
  label1: { textAlign: 'center', fontWeight: 'bold' },
  name: {
    color: '#C9AA4F',
    textAlign: 'center',
    marginBottom: '20px',
  },
  footerLogo: {
    width: '80px',
    height: '80px',
  },
  headerLogo: {
    width: '250px',
    height: '25px',
    // objectFit: 'contain',
  },
  sign: {
    width: '100px',
    height: '50px',
  },
}))

export default function CertificateDialog({ open, handleClose, certificate, signatures, handleCertificateSubmit, stateData }) {
  console.log('signatures : ', signatures)
  const classes = useStyles()
  const BorderLinesLeft = () => {
    return (
      <Box display="flex" style={{ position: 'absolute', top: 25, left: 10 }}>
        <Box className={classes.boldLine} />
        <Box className={classes.thinLine} />
      </Box>
    )
  }
  const BorderLinesRight = () => {
    return (
      <Box display="flex" style={{ position: 'absolute', top: 25, right: 10 }}>
        <Box className={`${classes.thinLine} ${classes.thinLine2}`} />
        <Box className={classes.boldLine} />
      </Box>
    )
  }
  return (
    <CustomDialog open={open} handleClose={handleClose} className={classes.dialog}>
      <Box display="flex">
        <BorderLinesLeft />
        <Box margin="auto" width="550px" textAlign="center">
          <CustomImage image={certificate.headerLogo[0] || Logo} className={classes.headerLogo} />

          <Typography className={classes.certificateHeading}>{certificate.certificateHeader || 'CERTIFICATE OF COMPLETION'} </Typography>
          <p className={classes.label1}>Presented to </p>
          <h1 className={classes.name}> KBC NAME </h1>
          <p className={classes.label1}> {certificate.certificateText || 'For completing KOHLER product induction program on'} </p>
          <p className={classes.label1}> 19th March 2021, </p>
          <p className={classes.label1}> securing 90% and is a certified {certificate.certified || 'KOHLER BOLD consultant'} </p>

          <Box display="flex" justifyContent="space-between" marginTop="50px">
            <Box>
              <CustomImage image={signatures && signatures[0].sign[0]} className={classes.sign} />
              <hr style={{ height: '3px', backgroundColor: 'black', width: '150px' }} />
              <span className={classes.label1} style={{ color: '#C9AA4F' }}>
                {(signatures && signatures[0].name) || 'KAMAL SHAH'}
              </span>
              <p className={classes.label1}> {(signatures && signatures[0].designation) || 'National Sales Head'} </p>
            </Box>
            <Box>
              <CustomImage image={certificate.footerLogo[0] || Logo2} className={classes.footerLogo} />
            </Box>
            <Box>
              <CustomImage image={signatures && signatures[1].sign[0]} className={classes.sign} />
              <hr style={{ height: '3px', backgroundColor: 'black', width: '130px' }} />
              <span className={classes.label1} style={{ color: '#C9AA4F' }}>
                {(signatures && signatures[1].name) || 'KAMAL SHAH'}
              </span>
              <p className={classes.label1}> {(signatures && signatures[1].designation) || 'National Sales Head'} </p>
            </Box>
          </Box>
        </Box>
        <BorderLinesRight />
      </Box>

      <Box display="flex" justifyContent="center" marginTop="20px" marginLeft="20px">
        <Box>
          <CustomButton text="Close" handleSubmit={handleClose} />
        </Box>
        <Box>
          <CustomButton text="Submit" handleSubmit={handleCertificateSubmit} />
        </Box>
      </Box>
    </CustomDialog>
  )
}
